import type { ButtonConfig } from '@/features/DataHub/types';

import type { IntegrationPreviewConfig } from '../types/exportConfig.types';

// Reusable preview config for integration options.
export const integrationPreview: IntegrationPreviewConfig = {
  type: 'integration'
};

export const integrationButtons: ButtonConfig[] = [
  {
    label: 'Enable Access',
    action: 'export'
  }
];
